import { FC } from 'react';
import { PasoInstructivo, PropsInstructivoNuevaOp } from '..';
import { Caja, Grilla, GrillaEl, PilaV, Texto } from '@/components/atomos';
import { Heading } from '@chakra-ui/react';

interface PropsPaso
  extends Omit<PasoInstructivo, "imagen">,
    Pick<PropsInstructivoNuevaOp, 'duracionSeccion'> {
  activo: boolean;
  numero: number;
}

type PropsBarraProgreso = Pick<PropsPaso, 'duracionSeccion'>;

const BarraProgreso: FC<PropsBarraProgreso> = ({ duracionSeccion }) => {
  return (
    <Caja
      position={'absolute'}
      w='full'
      bottom='0'
      h='1'
      bg='bGreen.700'
      animation={`animacionBarraProgreso linear ${duracionSeccion}ms`}
    />
  );
};

const Paso: FC<PropsPaso> = ({
  duracionSeccion,
  titulo,
  informacion,
  activo,
  numero,
}) => {
  return (
    <Grilla
      w={'full'}
      position={'relative'}
      templateColumns={'auto 1fr'}
      gap={2}
      py={5}
      filter={!activo ? 'grayscale(100%)' : ''}
      transition={'filter 500ms ease-in-out'}
    >
      <GrillaEl>
        <Texto color={'bGreen.700'}>{`0${numero}`}.</Texto>
      </GrillaEl>
      <GrillaEl as={PilaV} alignItems={'start'}>
        <Heading
          size={'md'}
          fontWeight={'medium'}
          as={'h3'}
          color={'bGreen.700'}
        >
          {titulo}
        </Heading>
        <Texto fontSize={'lg'} style={{ textWrap: 'balance' }}>
          {informacion}
        </Texto>
      </GrillaEl>
      {activo ? <BarraProgreso duracionSeccion={duracionSeccion} /> : null}
    </Grilla>
  );
};

const PasosInstructivo: FC<PropsInstructivoNuevaOp> = ({
  duracionSeccion,
  pasoActual,
  pasos,
}) => {
  return (
    <PilaV w={'full'}>
      {pasos.map((p, i) => {
        return (
          <Paso
            informacion={p.informacion}
            titulo={p.titulo}
            activo={i === pasoActual}
            duracionSeccion={duracionSeccion}
            numero={i + 1}
            key={p.titulo}
          />
        );
      })}
    </PilaV>
  );
};

export default PasosInstructivo;
